var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialTikTokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2271 0H10.8565V13.6232C10.8565 15.2464 9.56012 16.5797 7.94685 16.5797C6.33357 16.5797 5.0372 15.2464 5.0372 13.6232C5.0372 12.029 6.30477 10.7246 7.86044 10.6667V7.24639C4.43222 7.30433 1.66663 10.1159 1.66663 13.6232C1.66663 17.1594 4.48984 20 7.97567 20C11.4614 20 14.2847 17.1304 14.2847 13.6232V6.63767C15.5522 7.56522 17.1079 8.11594 18.75 8.14495V4.72464C16.2148 4.63768 14.2271 2.55072 14.2271 0Z",
    fill: "url(#paint0_linear_1128_154890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_154890",
    x1: 1.66663,
    y1: 10,
    x2: 18.75,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTikTokIcon);
export default __webpack_public_path__ + "static/media/SocialTikTokIcon.969eb0409d43faa50c2a9adbd25106f3.svg";
export { ForwardRef as ReactComponent };